export { Substitution as default } from "./substitution";
